import React from "react";

/**
 * Presentational stat card used across the dashboard.
 * Accent classes are passed as full strings so Tailwind can statically detect them.
 */
const StatCard = ({
	icon,
	label,
	value,
	accentBg = "bg-indigo-50",
	accentText = "text-indigo-600",
	accentBar = "from-indigo-500 to-indigo-400",
	loading = false,
}) => {
	return (
		<div className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg">
			<div className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r ${accentBar}`} />
			<div className="flex items-center gap-4 p-6">
				<div
					className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-xl text-2xl ${accentBg} ${accentText}`}>
					{icon}
				</div>
				<div className="min-w-0">
					<p className="truncate text-sm font-medium text-slate-500">{label}</p>
					{loading ? (
						<div className="mt-1 h-8 w-16 animate-pulse rounded bg-slate-200" />
					) : (
						<h4 className="text-3xl font-bold tracking-tight text-slate-800">
							{value}
						</h4>
					)}
				</div>
			</div>
		</div>
	);
};

export default StatCard;
